import React, { useId, useState } from "react";
import { FiChevronDown } from "react-icons/fi";

const SimpleAccordion = ({ title = "More on special terms", children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const contentId = useId();

  return (
    <div className="tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-dis-border tw-mt-1">
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
        aria-controls={contentId}
        className="tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-justify-between tw-gap-3 tw-border-0 tw-bg-transparent tw-px-0 tw-py-2.5 tw-text-left"
      >
        <span className="tw-text-base tw-font-bold tw-text-dis-navy">
          {title}
        </span>
        <FiChevronDown
          className={`tw-h-5 tw-w-5 tw-shrink-0 tw-text-dis-deep-blue tw-transition-transform tw-duration-200 tw-ease-in-out ${
            isOpen ? "tw-rotate-180" : "tw-rotate-0"
          }`}
          aria-hidden="true"
        />
      </button>

      {isOpen && (
        <div
          id={contentId}
          className="tw-pb-3 tw-text-dis-small tw-leading-[1.5] tw-text-dis-text-muted [&_a]:tw-text-dis-deep-blue [&_a]:tw-underline [&_a]:tw-underline-offset-2"
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default SimpleAccordion;
